import { useMutation } from "@apollo/client";
import { fetch as router } from "helpers/router";
import mapValidationErrors, { mapServerErrors } from "helpers/graphqlErrors";
import SIGNUP from "./queries/signup.gql";

const useAuthSignup = () => {
  const [signup, { data, loading, error }] = useMutation(SIGNUP, { errorPolicy: "all" });

  let location = null;
  let errors = {};
  let submitError = null;

  if (!loading && data && data.hasOwnProperty("signup")) {
    if (data.login !== null) {
      location = router("web.dashboard");
    }
  }

  if (!loading && error && error.graphQLErrors) {
    errors = mapValidationErrors(error.graphQLErrors);
    submitError = mapServerErrors(error.graphQLErrors);
    location = null;
  }

  return {
    signup: (email, name, password, captchaToken) => {
      signup({
        variables: {
          email,
          name,
          password,
        },
        context: {
          headers: {
            "x-captcha-token": captchaToken,
          },
        },
      });
    },
    location,
    errors,
    submitError,
  };
};

export default useAuthSignup;
